import {
    RECEIVE_INVOICES_GAS,
    SET_ITEMS_OFFSET_GAS,
    SET_FILTERS_GAS,
    CLEAR_INVOICE_PAGINATION_GAS,
    RECEIVE_INVOICES_FILTER_GAS,
    FETCH_INVOICES_REQUEST_GAS,
    FETCH_INVOICES_FILTER_REQUEST_GAS,
    EXPORT_INVOICE_REQUEST_GAS,
    EXPORT_INVOICE_DONE_GAS,
    LOGOUT_SUCCESS,
    RESET_INVOICES
} from '../../../constants';
import { createReducer } from '../../../utils/misc';
import Settings from "../../../settings";

const initialState = {
    filters: {
        loading: false,
        data: {},
        currentFilter: ''
    },
  isFetching: false,
  loaded: false,
  download_status: {},
  invoice_function: null,
  items: [],
  itemsPage: Settings?.invoices?.itemsPerPage ?? 100,
  itemsTotal: 0,
  itemsOffset: 0,
  errors: null
};

export default createReducer(initialState, {
    [RESET_INVOICES]: (state) => {
        return Object.assign({}, state, initialState)
    },
    [RECEIVE_INVOICES_GAS]: (state, payload) =>
    {
        return Object.assign({}, state, {
            items: payload.response.items,
            itemsTotal: payload.response.n_items,
            itemsOffset: payload.response.offset,
            itemsPage: payload.response.limit,
            isFetching: false,
            loaded: true,
            errors: payload.errors,
        })
    },
    [SET_ITEMS_OFFSET_GAS]: (state, payload) =>
      Object.assign({}, state, {
        itemsOffset: payload.itemsOffset
      }),
    [SET_FILTERS_GAS]: (state, payload) =>
      Object.assign({}, state, {
        itemsPage: payload.itemsPage,
        itemsOffset: payload.itemsOffset,
        filters: {
            ...state.filters,
            currentFilter: payload.currentFilter
        }
      }),
    [CLEAR_INVOICE_PAGINATION_GAS]: (state, payload) =>
      Object.assign({}, state, {
        itemsPage: Settings?.invoices?.itemsPerPage ?? 100,
        itemsTotal: 0,
        itemsOffset: 0,
      }),
    [RECEIVE_INVOICES_FILTER_GAS]: (state, payload) =>
      Object.assign({}, state, {
        filters: {
          ...state.filters,
          loading: false,
          data: payload
        }
      }),
    [FETCH_INVOICES_REQUEST_GAS]: (state, payload) =>
    {
        return {
            ...state,
            isFetching: true,
            loaded: false,
        }
    },
    [FETCH_INVOICES_FILTER_REQUEST_GAS]: (state, payload) =>
      Object.assign({}, state, {
        filters: {
          ...state.filters,
          loading: true,
          data: {}
        }
      }),
    [EXPORT_INVOICE_REQUEST_GAS]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = true;
        return Object.assign({}, state, {
            download_status,
        });
    },
    [EXPORT_INVOICE_DONE_GAS]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = false;
        return Object.assign({}, state, {
            download_status
        });
    },
    [LOGOUT_SUCCESS]: (state, payload) =>
        Object.assign({}, state, initialState),
});
